const nvpin = {
  category: '女频其他',
  categoryId: '2222',
  coverList: [
    {
      coverId: 2222001,
      template: 'vertical_2',
      title: {
        titleText: '',
        color: '#D70F1E',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(5deg, #E64A83 0%, #841332 100%)',
        color_mask: '#210909',
        font: '手刻宋',
        fontSize: '70',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#28090A',
      },
      padding: 70,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xiandaiyanqing/15-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 2222002,
      template: 'vertical_2',
      title: {
        titleText: '',
        color: '#FEB7A1',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(5deg, #E64A83 0%, #841332 100%)',
        color_mask: '#F97087',
        font: '手刻宋',
        fontSize: '70',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#F97488',
      },
      padding: 70,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xiandaiyanqing/16-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 2222003,
      template: 'vertical_2',
      title: {
        titleText: '',
        color: '#210909',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(5deg, #E64A83 0%, #841332 100%)',
        color_mask: '#8F0222',
        font: '手刻宋',
        fontSize: '70',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#28090A',
      },
      padding: 70,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xiandaiyanqing/17-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
  ],
};

export default nvpin;
